import React, { useContext, useState } from "react";
import PurpelBtn from "../../commanComponents/buttons/PurpelBtn";
import PaginationButton from "../../commanComponents/buttons/PaginationButton";
import SelectMine from "../../commanComponents/SelectMine";
import AddEditShift from "./AddEditShift";
import { useQuery } from "react-query";
import { communication } from "../../constants/apis/communication";
import toast from "react-hot-toast";
import useDebounce from "../../constants/helpers/useDebounce";
import Loader from "../../commanComponents/Loader";
import { PaginationContext } from "../../constants/context/PaginationProvider";
import { getUserDetails } from "../../constants/helpers/getUserDetails";

function ShiftList() {
  const { shiftPage, setShiftPage, globalSearchString } = useContext(PaginationContext);
  const debouncedSearchTerm = useDebounce(globalSearchString, 1000, setShiftPage);
  const [showModal, setShowModal] = useState({ isOpen: false, shiftId: null, isView: false, mineId: null });
  const [selectedMine, setSelectedMine] = useState(getUserDetails()?.mineId || "");

  const pageLimit = process.env.REACT_APP_PUBLIC_LIMIT || 10;

  const {
    data: shiftData,
    isFetching,
    refetch,
  } = useQuery(
    ["getAllShifts", shiftPage, debouncedSearchTerm, selectedMine],
    () =>
      communication?.getAllShifts({
        searchString: debouncedSearchTerm,
        page: shiftPage,
        mineId: selectedMine,
      }),
    {
      refetchOnWindowFocus: false,
      onSuccess: (data) => {
        if (data?.data?.status === "JWT_INVALID") {
          toast.error(`Failed: ${data?.data?.message}`);
        } else if (data?.data?.status === "FAILED") {
          toast.error(`Failed: ${data?.data?.message}`);
        }
      },
      onError: (error) => {
        toast.error(`Failed: ${error?.message}`);
      },
    }
  );
  const user = getUserDetails();
  const userRoles = Array.isArray(user?.designation) ? user.designation.map(d => d.toLowerCase()) : (typeof user?.designation === "string" ? [user.designation.toLowerCase()] : []);
  const isSuperAdmin = userRoles.includes("superadmin");

  return (
    <div>
      {isFetching && <Loader />}
      <div className="pageWrapper">
        <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 mb-2">
          <div className="d-flex align-items-center gap-3 flex-wrap">
            {" "}
            <PurpelBtn text={"Add Shift"} onClick={() => setShowModal({ isOpen: true, shiftId: null, isView: false, mineId: selectedMine })} />
          </div>
          <div className="d-flex align-items-center gap-3 flex-wrap">
            <SelectMine selectedMine={selectedMine} onChange={(e) => setSelectedMine(e.target.value)} />
            <PaginationButton setPage={setShiftPage} page={shiftPage} totalPages={shiftData?.data?.totalPages} pageName={"shift"} />
          </div>
        </div>
        <div className="tableWrapper comman-box-shadow" style={{ position: "relative", height: "72vh" }}>
          <table>
            <thead>
              <tr>
                <th className="text-center col_80px">Sr. No.</th>
                <th className="col_100px">Shift Name</th>
                {isSuperAdmin && <th className="col_100px">Mine Name</th>}
                {isSuperAdmin && <th className="col_90px">Mine Id</th>}
                <th className="col_100px">Start Time</th>
                <th className="col_100px">End Time</th>
                <th className="text-center row-fix-to-last col_150px">Action</th>
              </tr>
            </thead>
            <tbody>
              {shiftData?.data?.shifts?.map((ele, index) => {
                return (
                  <tr key={ele._id} className={index % 2 === 0 && "skyBlueTrBg"}>
                    <td className="text-center">{(shiftPage - 1) * pageLimit + (index + 1)}</td>
                    <td className="">{ele?.shift || "--"}</td>
                    {isSuperAdmin && (
                      <>
                        <td className="">{ele?.mineName || "--"}</td>
                        <td>{ele?.mineCode || "--"}</td>
                      </>
                    )}
                    <td>{ele?.startTime || "--"}</td>
                    <td>{ele?.endTime || "--"}</td>
                    <td className="text-center d-flex gap-3 justify-content-center align-items-center row-fix-to-last">
                      <button onClick={() => setShowModal({ isOpen: true, shiftId: ele?._id, isView: true })} className="premiumActionBtn view" title="View">
                        <span>View</span>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                          <circle cx="12" cy="12" r="3"></circle>
                        </svg>
                      </button>
                      <button onClick={() => setShowModal({ isOpen: true, shiftId: ele?._id, isView: false })} className="premiumActionBtn edit" title="Edit">
                        <span>Edit</span>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
                        </svg>
                      </button>
                    </td>
                  </tr>
                );
              })}
              {(!shiftData?.data?.shifts || shiftData?.data?.shifts.length === 0) && !isFetching && (
                <tr>
                  <td colSpan="7" className="text-center">
                    No shifts found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      {showModal.isOpen && (
        <AddEditShift
          shiftId={showModal.shiftId}
          isViewMode={showModal.isView}
          mineId={showModal.mineId}
          onClose={() => {
            setShowModal({ isOpen: false, shiftId: null, isView: false, mineId: null });
            refetch();
          }}
        />
      )}
    </div>
  );
}

export default ShiftList;
